import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../../infrastructure/content';

class TechnicalErrorPage extends Component {
  constructor() {
    super();
    this.state = {
      isExitModalOpen: false
    };
  }
  render() {
    return (
      <Content>
        {({ technicalErrorHeader, technicalErrorLead, technicalErrorPara }) => (
          <div>
            <PageHeading>{technicalErrorHeader}</PageHeading>
            <p>{technicalErrorLead}</p>
            <p>{technicalErrorPara}</p>
          </div>
        )}
      </Content>
    );
  }
}

export default TechnicalErrorPage;
